import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=e8e709a2&scoped=true"
import script from "./table-page.vue?vue&type=script&lang=js"
export * from "./table-page.vue?vue&type=script&lang=js"
import style0 from "./table-page.vue?vue&type=style&index=0&id=e8e709a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e709a2",
  null
  
)

export default component.exports